<template>
    <div id="page-user-list">
        <div class="vx-card no-shadow p-6"> 
            <div class="flex flex-wrap items-center">
                <vx-input-group class="sm:w-6/12 w-full sm:order-normal order-3 sm:mt-0 mt-4">
                    <vs-input v-model="searchQuery" @blur="updateSearchQuery" @keyup.enter="updateSearchQuery" placeholder="Search" />
                    <template slot="append">
                        <div class="append-text btn-addon">
                            <vs-button color="primary" icon-pack="feather" icon="icon-search"></vs-button>
                        </div>
                    </template>
                </vx-input-group>
                <div class="cursor-pointer text-right sm:w-6/12 w-full sm:mb-0 mb-2">
                    <router-link tag="span" to="/vacant-properties/new" class="vs-button vs-button-primary vs-button-filled text-white" >Add Vacant Property</router-link>
                </div>          
            </div>

            <!-- AgGrid Table -->
            <ag-grid-vue
                ref="agGridTable"
                :components="components"
                :gridOptions="gridOptions"
                :rowData="propertiesResponse.properties"
                class="ag-theme-material w-100 my-4 ag-grid-table ag-grid-table-border ag-grid-custome-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                rowSelection="multiple"
                colResizeDefault="shift"
                :animateRows="true"
                :pagination="true"
                :context="this"
                :paginationPageSize="paginationPageSize"
                :suppressPaginationPanel="true"
                :enableRtl="$vs.rtl">
            </ag-grid-vue>

            <vs-pagination
                :total="propertiesResponse.count"
                :max="10"
                v-model="currentPage" />
        </div>
    </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import VacantProperty from '@/js/vacantProperty.js'

import CellRendererList from '@/views/cellRender/CellRendererList.vue'
import CellRendererStatus from '@/views/cellRender/CellRendererStatus.vue'
import CellRendererCurrency from '@/views/cellRender/CellRendererCurrency.vue'
import CellRendererActions from './CellRendererActions.vue'

export default {
  components: {
    AgGridVue,
    vSelect,
    CellRendererList,
    CellRendererStatus,
    CellRendererCurrency,
    CellRendererActions
  },
  data () {
    return {
      searchQuery: '',
      propertiesResponse: {count: 1},

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: '#',
          field: 'index',
          width: 100
        },
        {
          headerName: 'Property Address',
          field: 'address',
          cellRendererFramework: 'CellRendererList',
          width: 338
        },
        {
          headerName: 'Property Type',
          field: 'property_type',
          width: 170
        },
        {
          headerName: 'Status',
          field: 'status',
          cellRendererFramework: 'CellRendererStatus',
          width: 135
        },
        {
          headerName: 'Security Deposit',
          field: 'security_deposit',
          CellRendererCurrency: 'CellRendererCurrency',
          width: 165
        },
        {
          headerName: 'Monthly Rent',
          field: 'monthly_rent',
          CellRendererCurrency: 'CellRendererCurrency',
          width: 185
        },
        {
          headerName: 'Actions',
          cellRendererFramework: 'CellRendererActions',
          field: 'transactions',
          width: 95
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererList,
        CellRendererStatus,
        CellRendererCurrency,
        CellRendererActions
      }
    }
  },
  computed: { 
    baseUrl () {
      const path = this.$route.path
      console.log('path', path)
      return path.slice(0, path.lastIndexOf('/'))
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.slectedPage = val
        this.onGridReady()
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },  
    setVacantProperties (propertiesResponse) {
      this.propertiesResponse = propertiesResponse
    }, 
    updateSearchQuery () {
      this.currentPage = 1
    },
    onGridReady () {
      VacantProperty.getVacantProperties(this)
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api

    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  created () {   
  }
}

</script>